export class MdBadge {
  constructor() {
    this.restrict = 'A';
    this.controller = MdBadgeController;
    this.link = this.link.bind(this);
  }

  link(scope, element, attributes) {
    scope.mdTheming(element);

    const parent = element.parent();
    const badge = angular.element('<div></div>');
    const offsetTop = parseInt(attributes.mdBadgeOffsetTop, 10) || 0;
    const offsetRight = parseInt(attributes.mdBadgeOffsetRight, 10) || 0;

    badge.addClass('md-badge');
    badge.css('position', 'absolute');
    badge.css(
      'background-color',
      scope.mdColorUtil.rgbaToHex(scope.mdColors.getThemeColor('accent'))
    );

    parent.append(badge);

    scope.$watch(() => attributes.mdBadge, value => {
      if (angular.isUndefined(value) || value < 1) {
        badge.css('display', 'none');
      } else {
        badge.css('display', 'flex');
      }

      badge.text(getTextValue(value));
    });

    scope.$watch(() => attributes.mdBadgeColor, value => {
      badge.css('color', value);
    });

    scope.$watch(
      () => ({
        top: element.prop('offsetTop'),
        left: element.prop('offsetLeft'),
        width: element.prop('offsetWidth'),
        height: element.prop('offsetHeight')
      }),
      value => {
        position(value);
      },
      true
    );

    const position = value => {
      badge.css('left', value.left + value.width - 20 + offsetRight + 'px');
      badge.css('top', value.top + value.height - 20 + offsetTop + 'px');
    };

    const getTextValue = value => (value > 99 ? '99+' : value);
  }
}

class MdBadgeController {
  constructor($scope, $mdTheming, $mdColors, $mdColorUtil) {
    $scope.mdTheming = $mdTheming;
    $scope.mdColors = $mdColors;
    $scope.mdColorUtil = $mdColorUtil;
  }
}

MdBadgeController.$inject = ['$scope', '$mdTheming', '$mdColors', '$mdColorUtil'];
